import Head from 'next/head'

export const Meta = ({
  title,
  description,
  image,
  imageAlt,
}: {
  title?: string
  description?: string
  image?: string
  imageAlt?: string
}) => (
  <Head>
    {title && <meta content={title} property='og:title' />}
    {description && <meta content={description} property='og:description' />}
    {image && <meta content={image} property='og:image' />}
    {imageAlt && <meta content={imageAlt} property='og:image:alt' />}
  </Head>
)
